<shared-breadcrumbs [ComponentData]="BreadcrumbsData"></shared-breadcrumbs>

<div class="pg-content__inner-transparent">
  <div class="pg-wrapper">
    <div class="sign-up__loading animated faster fadeIn" *ngIf="SignUpLoading">
      <div class="ui-loader ui-loader__page-dark"></div>
    </div>

    <div class="sign-up__wrapper"
      ngClass="{{SignUpLoading ? 'loading' : ''}}">

      <div class="row"
        ngClass="{{(deviceValue | async) === DTypes.Desktop ? 'pt-6 pb-6' : 'pt-4 pb-4'}}">

        <div class="sign-up__heading">
          <h1>Регистрация</h1>
        </div>
        <p class="txt-caption text-center mb-0" *ngIf="route.snapshot.queryParams['intent'] === 'musician'">
          Регистрация музыканта: после базовых полей укажите должность и инструменты.
        </p>
      </div>
      <div class="row" *ngIf="route.snapshot.queryParams['intent'] === 'bookingIndividual'">
        <div class="grid align-items-center justify-content-center mb-4">
          <div class="sign-up__customer-tab-switcher" role="radiogroup" aria-label="Тип регистрации заказчика">
            <input
              type="radio"
              class="sign-up__tab-input"
              name="signUpCustomerType"
              id="signUpCustomerTabIndividual"
              value="individual"
              [checked]="SignUpCustomerType === 'individual'"
              (change)="setCustomerType('individual')" />
            <label class="sign-up__tab-label" for="signUpCustomerTabIndividual">
              <span>Частное лицо</span>
            </label>
            <input
              type="radio"
              class="sign-up__tab-input"
              name="signUpCustomerType"
              id="signUpCustomerTabVenue"
              value="venue"
              [checked]="SignUpCustomerType === 'venue'"
              (change)="setCustomerType('venue')" />
            <label class="sign-up__tab-label" for="signUpCustomerTabVenue">
              <span>Юрлицо</span>
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="sign-up__addition">
          <div class="grid align-items-start"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : ''}}">

            <div class="col-6 col-sm-12"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'order-1 pt-6' : ''}}">
              <div class="sign-up__addition-title">
                <h5>Загрузите аватар</h5>
              </div>
              <div class="sign-up__addition-event">
                <div class="sign-up__addition-event__clear" *ngIf="SignUpAvatar" (click)="onUploadAvatarClear()">
                  <i class="pi pi-times-circle"></i>
                </div>

                <div class="sign-up__addition-event__avatar">
                  <input type="file" id="avatarUpload" class="sign-up__addition-event__avatar-input"
                    (change)="onUploadAvatarEvent($event.target['files'])"
                    [accept]="fileAcceptString">

                  <span class="ui-graphics__balalaika-light" *ngIf="!SignUpAvatar"></span>
                  <img src="{{SignUpAvatar}}" *ngIf="SignUpAvatar">

                  <div class="sign-up__addition-event__avatar-link" (click)="onUploadAvatarHandler()">
                    <div class="grid align-items-center justify-content-center">
                      <i class="pi pi-upload"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sign-up__addition-helper">
                <p>Размер не должен превышать 1Mb.<br/>Допустимые типы файлов: jpg, png, gif.</p>
              </div>
            </div>

            <div class="col-6 col-sm-12"
              ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'order-0 pt-6' : ''}}">
              <div class="sign-up__addition-title">
                <h5>Войти или зарегистрироваться</h5>
              </div>
              <div class="sign-up__addition-event">
                <div class="row sign-up__social">
                  <div class="grid h-full align-items-center justify-content-center">
                    <div class="col-auto sign-up__social-link" (click)="oauthService.onOAuthWindow(OAuthTypes.VKontakte)">
                      <span class="mr-icon mr-icon-vk-color">
                        <span class="path1"></span>
                        <span class="path2"></span>
                      </span>
                    </div>
                    <div class="col-auto sign-up__social-link" (click)="oauthService.onOAuthWindow(OAuthTypes.Odnoklassniki)">
                      <span class="mr-icon mr-icon-od-color">
                        <span class="path1"></span>
                        <span class="path2"></span>
                        <span class="path3"></span>
                      </span>
                    </div>
                    <div class="col-auto sign-up__social-link" (click)="oauthService.onOAuthWindow(OAuthTypes.Google)">
                      <span class="mr-icon mr-icon-google-color">
                        <span class="path1"></span>
                        <span class="path2"></span>
                        <span class="path3"></span>
                        <span class="path4"></span>
                        <span class="path5"></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sign-up__addition-helper">
                <p>Вы можете войти или зарегистрироваться<br/> через социальную сеть.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <form class="sign-up__forms" [formGroup]="SignUpForm" autocomplete="off">
          <div class="grid align-items-center"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">
            <div
              class="col-sm-12 no-padding"
              [ngClass]="route.snapshot.queryParams['intent'] === 'bookingIndividual' && SignUpCustomerType === 'venue' ? 'col-6' : 'col-12'">
              <div class="sign-up__forms-input"
                [ngClass]="{
                  'mt-4': (deviceValue | async) === DTypes.Mobile,
                  'pr-4': (deviceValue | async) !== DTypes.Mobile && route.snapshot.queryParams['intent'] === 'bookingIndividual' && SignUpCustomerType === 'venue'
                }">

                <div class="ui-input__placeholder">
                  <p>E-mail</p>
                  <span class="require">*</span>
                  <p class="error-holder" *ngIf="ErrorsField.email.status">
                    {{ErrorsField.email.value}}
                  </p>
                </div>
                <div class="ui-input ui-input__text"
                  ngClass="{{ErrorsField.email.status ? 'error' : ''}}">

                  <input type="text" placeholder="E-mail" formControlName="email" (blur)="onCheckInput('email')">
                </div>
              </div>
            </div>
            <div
              class="col-6 col-sm-12 no-padding"
              *ngIf="route.snapshot.queryParams['intent'] === 'bookingIndividual' && SignUpCustomerType === 'venue'">
              <div class="sign-up__forms-input"
                [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-4'">
                <div class="ui-checkbox mt-2">
                  <input
                    id="readyToAcceptApplicationsSignUp"
                    type="checkbox"
                    formControlName="readyToAcceptApplications" />
                  <label for="readyToAcceptApplicationsSignUp">
                    <span class="ui-checkbox__text">Готовы принимать заявки</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="grid align-items-end"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">

            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pr-4'}}">

                <div class="ui-input__placeholder">
                  <p *ngIf="route.snapshot.queryParams['intent'] !== 'bookingIndividual' || SignUpCustomerType !== 'venue'">Имя</p>
                  <p *ngIf="route.snapshot.queryParams['intent'] === 'bookingIndividual' && SignUpCustomerType === 'venue'">Имя представителя</p>
                  <span class="require">*</span>
                  <p class="error-holder" *ngIf="ErrorsField.firstName.status">
                    {{ErrorsField.firstName.value}}
                  </p>
                </div>
                <div class="ui-input ui-input__text"
                  ngClass="{{ErrorsField.firstName.status ? 'error' : ''}}">
                  <input type="text" [placeholder]="route.snapshot.queryParams['intent'] === 'bookingIndividual' && SignUpCustomerType === 'venue' ? 'Имя представителя' : 'Имя'" formControlName="firstName">
                </div>
              </div>
            </div>

            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-4'}}">

                <div class="ui-input__placeholder">
                  <p *ngIf="route.snapshot.queryParams['intent'] !== 'bookingIndividual' || SignUpCustomerType !== 'venue'">Фамилия</p>
                  <p *ngIf="route.snapshot.queryParams['intent'] === 'bookingIndividual' && SignUpCustomerType === 'venue'">Фамилия представителя</p>
                  <span class="require" *ngIf="route.snapshot.queryParams['intent'] === 'bookingIndividual' || route.snapshot.queryParams['intent'] === 'musician'">*</span>
                </div>
                <div class="ui-input ui-input__text">
                  <input type="text" [placeholder]="route.snapshot.queryParams['intent'] === 'bookingIndividual' && SignUpCustomerType === 'venue' ? 'Фамилия представителя' : 'Фамилия'" formControlName="lastName">
                </div>
              </div>
            </div>
          </div>

          <div class="grid align-items-end"
            *ngIf="route.snapshot.queryParams['intent'] === 'bookingIndividual'"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">
            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                [ngClass]="(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pr-4'">
                <div class="ui-input__placeholder">
                  <p *ngIf="SignUpCustomerType !== 'venue'">Дата рождения</p>
                  <p *ngIf="SignUpCustomerType === 'venue'">Дата рождения представителя</p>
                  <span class="require">*</span>
                </div>
                <div class="ui-input ui-input__text">
                  <input type="text" placeholder="01.01.1990" formControlName="birthday">
                </div>
              </div>
            </div>
            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-4'}}">

                <div class="ui-input__placeholder">
                  <p>Город</p>
                  <span class="require">*</span>
                  <p class="error-holder" *ngIf="ErrorsField.cityId.status">
                    {{ErrorsField.cityId.value}}
                  </p>
                </div>
                <div class="ui-input ui-input__text"
                  ngClass="{{ErrorsField.cityId.status ? 'error' : ''}}">
                  <div class="ui-input__cup cta ui-scroll-horizontal" (click)="onViewSearchCities()">
                    <input type="text" (focus)="onViewSearchCities()" readonly>
                    <span *ngIf="!SignUpCityValue">Выбрать город</span>

                    <p-chip *ngIf="SignUpCityValue"
                      label="{{SignUpCityValue.name}}"
                      styleClass="input__chip">
                    </p-chip>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="grid align-items-end"
            *ngIf="route.snapshot.queryParams['intent'] === 'bookingIndividual'"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">

            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pr-4'}}">

                <div class="ui-input__placeholder">
                  <p>Телефон</p>
                  <span class="require">*</span>
                  <p class="error-holder" *ngIf="ErrorsField.phone.status">
                    {{ErrorsField.phone.value}}
                  </p>
                </div>
                <div class="ui-input ui-input__text"
                  ngClass="{{ErrorsField.phone.status ? 'error' : ''}}">
                  <input type="text" placeholder="+7 (911) 111-11-11"
                    formControlName="phone"
                    mask="+0 (000) 000-00-00"
                    (input)="onMaskPhone($event)"
                    (blur)="onCheckPhone()">
                </div>
              </div>
            </div>

            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-4'}}">

                <div class="ui-input__placeholder">
                  <p>Мессенджеры, привязанные к телефону</p>
                </div>
                <div class="sign-up__forms-messengers">
                  <div class="grid align-items-center">
                    <div class="col-auto">
                      <span class="mr-icon mr-icon-telegram-color" (click)="onSetMessengerValue('hasTelegram')"
                        ngClass="{{onGetMessengerStatus('hasTelegram') ? 'selected' : ''}}">
                        <span class="path1"></span>
                        <span class="path2"></span>
                      </span>
                    </div>
                    <div class="col-auto">
                      <span class="mr-icon mr-icon-max-color" (click)="onSetMessengerValue('hasMax')"
                        ngClass="{{onGetMessengerStatus('hasMax') ? 'selected' : ''}}"
                        title="Max">
                        <span class="path1"></span>
                        <span class="path2"></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="booking-venue-fields-wrap"
            *ngIf="route.snapshot.queryParams['intent'] === 'bookingIndividual' && SignUpCustomerType === 'venue'"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column mb-4' : 'mb-4'}}">
            <app-venue-customer-profile-fields
              [form]="SignUpForm"
              [genres]="Genres"
              layout="signUp"
              (innValidationStateChange)="onVenueInnValidationStateChange($event)">
            </app-venue-customer-profile-fields>
          </div>

          <div class="grid"
            *ngIf="route.snapshot.queryParams['intent'] === 'bookingIndividual'"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">
            <div class="col-12 no-padding sign-up__booking-social">
              <div class="sign-up__booking-social-head mt-2 mb-2">
                <div class="ui-input__placeholder sign-up__booking-social-title">
                  <p>Соцсети <span class="require">*</span></p>
                </div>
              </div>
              <div class="sign-up__booking-social-list" formArrayName="socialLinks">
                <div
                  class="grid align-items-end mb-2 sign-up__booking-social-row"
                  *ngFor="let row of bookingSocialLinksArray.controls; let i = index; trackBy: trackByBookingSocialIndex"
                  [formGroupName]="i">
                  <div class="col-12 col-sm-5">
                    <p-dropdown
                      formControlName="platform"
                      [options]="SocialPlatforms"
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Площадка"
                      styleClass="p-dropdown__bulletins w-full">
                    </p-dropdown>
                  </div>
                  <div
                    class="col-12 sign-up__booking-social-url"
                    [ngClass]="bookingSocialLinksArray.length > 1 ? 'col-sm-6' : 'col-sm-7'">
                    <div class="ui-input ui-input__text">
                      <input type="text" formControlName="url" placeholder="https://..." />
                    </div>
                  </div>
                  <div class="col-12 col-sm-1 text-right" *ngIf="bookingSocialLinksArray.length > 1">
                    <button type="button" class="ui-buttons ui-buttons__light-small"
                      (click)="removeBookingSocialLink(i)"
                      [attr.aria-label]="'Удалить ссылку'">×</button>
                  </div>
                </div>
              </div>
              <div class="sign-up__booking-social-add-wrap">
                <button type="button" class="ui-buttons ui-buttons__light-small" (click)="addBookingSocialLink()">Добавить ссылку</button>
              </div>
            </div>
          </div>

          <div
            class="booking-venue-facilities-wrap"
            *ngIf="route.snapshot.queryParams['intent'] === 'bookingIndividual' && SignUpCustomerType === 'venue'"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column mb-4' : 'mb-4'}}">
            <app-venue-customer-facilities-fields [form]="SignUpForm" layout="signUp">
            </app-venue-customer-facilities-fields>
          </div>
          <div class="grid align-items-end"
            *ngIf="route.snapshot.queryParams['intent'] !== 'bookingIndividual'"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">

            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pr-4'}}">

                <div class="ui-input__placeholder">
                  <p>Город</p>
                  <span class="require">*</span>
                  <p class="error-holder" *ngIf="ErrorsField.cityId.status">
                    {{ErrorsField.cityId.value}}
                  </p>
                </div>
                <div class="ui-input ui-input__text"
                  ngClass="{{ErrorsField.cityId.status ? 'error' : ''}}">
                  <div class="ui-input__cup cta ui-scroll-horizontal" (click)="onViewSearchCities()">
                    <input type="text" (focus)="onViewSearchCities()" readonly>
                    <span *ngIf="!SignUpCityValue">Выбрать город</span>

                    <p-chip *ngIf="SignUpCityValue"
                      label="{{SignUpCityValue.name}}"
                      styleClass="input__chip">
                    </p-chip>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-4'}}">

                <div class="ui-input__placeholder">
                  <p>Телефон</p>
                  <span class="require" *ngIf="route.snapshot.queryParams['intent'] === 'bookingIndividual' && SignUpCustomerType === 'venue'">*</span>
                  <p class="error-holder" *ngIf="ErrorsField.phone.status">
                    {{ErrorsField.phone.value}}
                  </p>
                </div>
                <div class="ui-input ui-input__text"
                  ngClass="{{ErrorsField.phone.status ? 'error' : ''}}">
                  <input type="text" placeholder="+7 (911) 111-11-11"
                    formControlName="phone"
                    mask="+0 (000) 000-00-00"
                    (input)="onMaskPhone($event)"
                    (blur)="onCheckPhone()">
                </div>
              </div>
            </div>
          </div>

          <div class="grid align-items-end"
            *ngIf="route.snapshot.queryParams['intent'] === 'musician'"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">
            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pr-4'}}">
                <div class="ui-input__placeholder">
                  <p>Дата рождения</p>
                  <span class="require">*</span>
                </div>
                <div class="ui-input ui-input__text">
                  <input type="text" placeholder="01.01.1990" formControlName="birthday">
                </div>
              </div>
            </div>
            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-4'}}">
                <div class="ui-input__placeholder">
                  <p>Инструмент и должность</p>
                  <span class="require">*</span>
                </div>
                <div class="ui-input ui-input__text">
                  <div class="ui-input__cup cta ui-scroll-horizontal" (click)="onViewSearchActivityForMusician()">
                    <span *ngIf="!signUpActivityPosition && !signUpActivityInstruments.length">
                      Выбрать инструмент или должность
                    </span>
                    <div class="grid align-items-center flex-nowrap"
                      *ngIf="signUpActivityPosition || signUpActivityInstruments.length">
                      <p-chip *ngIf="signUpActivityPosition"
                        label="{{signUpActivityPosition.title}}"
                        styleClass="input__chip">
                      </p-chip>
                      <ng-container *ngFor="let instrument of signUpActivityInstruments">
                        <p-chip label="{{instrument.title}}" styleClass="input__chip"></p-chip>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="grid align-items-end"
            *ngIf="!SignUpExternal"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">

            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pr-4'}}">

                <div class="ui-input__placeholder">
                  <p>Пароль</p>
                  <span class="require">*</span>
                  <p class="error-holder" *ngIf="ErrorsField.password.status">
                    {{ErrorsField.password.value}}
                  </p>
                </div>
                <div class="ui-input ui-input__text"
                  ngClass="{{ErrorsField.password.status || ErrorsField.password_repeat.status ? 'error' : ''}}">
                  <input type="password" placeholder="Введите пароль" formControlName="password"
                    [attr.maxlength]="passwordMaxLen" />
                </div>
              </div>
            </div>

            <div class="col-6 col-sm-12 no-padding">
              <div class="sign-up__forms-input"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'pl-4'}}">

                <div class="ui-input__placeholder">
                  <p>Повторить пароль</p>
                  <span class="require">*</span>
                  <p class="error-holder" *ngIf="ErrorsField.password_repeat.status">
                    {{ErrorsField.password_repeat.value}}
                  </p>
                </div>
                <div class="ui-input ui-input__text"
                  ngClass="{{ErrorsField.password.status || ErrorsField.password_repeat.status ? 'error' : ''}}">
                  <input type="password" placeholder="Повторите пароль" formControlName="password_repeat"
                    [attr.maxlength]="passwordMaxLen" />
                </div>
              </div>
            </div>
          </div>

          <div class="grid align-items-end"
            ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column' : 'mb-4'}}">

            <div class="col-12 col-sm-12 no-padding">
              <div class="row"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-6' : 'text-center mt-2'}}">

                <div class="ui-checkbox">
                  <input id="remember" type="checkbox" formControlName="processing">
                  <label for="remember">
                    <span class="ui-checkbox__text">Согласие с обработкой персональных данных </span>
                  </label>
                </div>
              </div>

              <div class="row"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-6' : 'mt-6'}}">
                <div class="grid align-items-start">
                  <p class="txt-require pr-1">*</p>
                  <p class="txt-caption__large">— Обязательны для заполнения: имя, e-mail, город, пароль и подтверждение пароля.</p>
                </div>
              </div>

              <div class="row mb-8"
                ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-2' : 'mt-2'}}">

                <p class="txt-caption__large">
                  При регистрации вы подтверждаете согласие с
                  <a routerLink="/{{Routing.Pages}}/{{Routing.Rules}}" target="_blank">условиями использования Музыканты России</a> и
                  <a routerLink="/{{Routing.Pages}}/{{Routing.Confidential}}" target="_blank">политикой о данных пользователей.</a>
                </p>
              </div>

              <div class="sign-up__forms-errors __sign-up__errors">
                <div class="grid justify-content-center"
                  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'align-items-center' : 'align-items-baseline'}}">

                  <span class="mr-icon mr-icon-status-error"></span>
                  <p>{{ErrorsText}}</p>
                </div>
              </div>

              <div class="row mt-4">
                <div class="grid align-items-center justify-content-center">
                  <div class="col-4 col-sm-12">
                    <button class="ui-buttons ui-buttons__blue-large" (click)="onSubmitForm()" pRipple>
                      Зарегистрироваться
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>

    </div>
  </div>

  <p-toast position="top-center" key="signUpToast"
    [baseZIndex]="5000"
    [styleClass]="'p-toast__sign-up'">
  </p-toast>
</div>
